import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../ui";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import localization from "../../../config/localization";
import { Link } from "react-router-dom";

interface SidebarHeaderProps {
  onClose: () => void;
  handleNavigate: (path: string) => void;
  isAuthenticated: boolean;
}

export function SidebarHeader({

  onClose,
  handleNavigate,
  isAuthenticated,
}: SidebarHeaderProps) {
  return (
    <div className="flex items-center justify-between p-4 bg-[#121212]">
      <Link to="/" className="relative flex mt-4">
        <img src={"/images/logo.svg"} alt="Logo" className="h-20 w-auto object-contain" />
      </Link>

      <div className="flex items-center gap-4">
        {!isAuthenticated && (
          <>
            <Button
              className="text-white font-medium hover:opacity-80 transition cursor-pointer capitalize"
              onClick={() => handleNavigate("/login")}
            >
              {localization.login.toLowerCase()}
            </Button>
            <Button
              className="bg-primary-gradient px-4 py-2 rounded-md font-semibold hover:opacity-90 transition capitalize"
              onClick={() => handleNavigate("/signup")}
            >
              <span>{localization.joinNow.toLowerCase()}</span>
            </Button>
          </>
        )}

        <Button
          onClick={onClose}
          className="ml-2 text-gray-400 hover:text-white"
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faXmark} size="lg" />
        </Button>
      </div>
    </div>
  );
}
